module.exports = __webpack_public_path__ + "img/wrk-2x_233c193f1db632f7f7f8ec598d2b7a78.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/wrk-2x.jpg
// module id = 298
// module chunks = 0